export const encryptionKeyInfoSchema = {
    $id: 'urn:wisepipe-common-auth:EncryptionKeyInfo',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        keyID: { type: 'string', uid: 9 },
        keyName: { type: 'string', minLength: 1 },
        publicKey: { type: 'string', minLength: 1 },
        createdAt: { type: 'string', format: 'date-time' },
        expireAt: { type: 'string', format: 'date-time' }
    },
    required: ['orgID', 'keyID', 'keyName', 'publicKey', 'createdAt']
};
//# sourceMappingURL=encryptionKeyInfo.js.map